import { register } from '../../../JavaScript/Utils'

const PriceTable = el => {
  const navMobileContainer = el.querySelector('.nav-mobile')
  const navMobileButtons = navMobileContainer.querySelectorAll('.nav-button')
  const buttonPro = el.querySelector('.button-pro')
  const buttonStandard = el.querySelector('.button-standard')
  const buttonBasic = el.querySelector('.button-basic')
  const optionNotBasic = el.querySelectorAll('.not-basic')
  const isMobile = el.querySelectorAll('.is-mobile')
  const isOptional = el.querySelectorAll('.is-optional')
  const serviceTimePro = el.querySelector('.service-time-pro')
  const serviceTimeStandard = el.querySelector('.service-time-standard')

  /**
   * initially activate and hide elements
   */
  buttonStandard.classList.add('active')
  serviceTimePro.classList.add('hidden')

  isOptional.forEach(option => {
    option.classList.add('hidden')
  })

  /**
   * change active nav class on click
   */
  navMobileButtons.forEach(button => {
    button.addEventListener('click', () => {
      navMobileButtons.forEach(button => {
        button.classList.remove('active')
      })
      button.classList.add('active')
    })
  })

  /**
   * toggle hidden class on options
   */
  // show all options
  const showAllOptions = () => {
    optionNotBasic.forEach(option => {
      option.classList.remove('hidden')
    })
  }

  // on pro button click, show non basic options and specific texts
  buttonPro.addEventListener('click', () => {
    showAllOptions()
    serviceTimePro.classList.remove('hidden')
    serviceTimeStandard.classList.add('hidden')
    isOptional.forEach(option => {
      option.classList.add('hidden')
    })
  })

  // on standard button click, show non basic options and specific texts
  buttonStandard.addEventListener('click', () => {
    showAllOptions()
    serviceTimeStandard.classList.remove('hidden')
    serviceTimePro.classList.add('hidden')
    isOptional.forEach(option => {
      option.classList.remove('hidden')
    })
  })

  // on basic button click, hide non basic options and specific texts
  buttonBasic.addEventListener('click', () => {
    serviceTimeStandard.classList.add('hidden')
    serviceTimePro.classList.add('hidden')
    optionNotBasic.forEach(option => {
      option.classList.add('hidden')
    })
  })

  /**
   * remove and hide options when not mobile view
   */
  window.addEventListener('resize', () => {
    const mql = window.matchMedia('screen and (min-width: 768px)')
    if (mql.matches) {
      optionNotBasic.forEach(option => {
        option.classList.remove('hidden')
      })

      isMobile.forEach(option => {
        option.classList.add('hidden')
      })

      isOptional.forEach(option => {
        option.classList.add('hidden')
      })
    }

    serviceTimePro.classList.add('hidden')
    serviceTimeStandard.classList.add('hidden')

    /**
     * hide not basic options, when basic active and resize back to mobile and set active classes
     */
    const mqs = window.matchMedia('screen and (max-width: 767px)')
    if (mqs.matches) {
      if (buttonBasic.classList.contains('active')) {
        optionNotBasic.forEach(option => {
          option.classList.add('hidden')
        })
      }

      if (!buttonBasic.classList.contains('active')) {
        isMobile.forEach(option => {
          option.classList.remove('hidden')
        })
      }

      if (buttonPro.classList.contains('active')) {
        serviceTimePro.classList.remove('hidden')
      } else if (buttonStandard.classList.contains('active')) {
        serviceTimePro.classList.add('hidden')
        serviceTimeStandard.classList.remove('hidden')
        isOptional.forEach(option => {
          option.classList.remove('hidden')
        })
      } else {
        serviceTimePro.classList.add('hidden')
        serviceTimeStandard.classList.add('hidden')
      }
    }
  })

  /**
   * show optional items on load if mobile
   */
  window.addEventListener('load', () => {
    const mqs = window.matchMedia('screen and (max-width: 767px)')
    if (mqs.matches) {
      if (buttonStandard.classList.contains('active')) {
        isOptional.forEach(option => {
          option.classList.remove('hidden')
        })
      }
    }
  })
}

register('PriceTable', PriceTable)
